export const EXCEL_FILENAMES_CHUNK_SIZE = 200;
export const BATCH_IMAGES_CHUNK_SIZE = 200;
